import React from "react";
import KogAutoCompleteOutlinedControlled from "@/main/components/shared/inputAutoComplete/autoCompleteOutlinedControlled";
import KogTextAreaControlledNew from "@/main/components/shared/textArea/textArea";
import { useFormContext, useWatch } from "react-hook-form";
import { useReasonReducer } from "@/main/store/reason";
import { getTranslateByKey } from "@/main/services/utils";
import { convertStringForBoolean } from "@/main/services/utilsString";
import { ICreateAnswerForm } from "../../../interfaceCreateAnswer";
import useAsyncModalConfirm from "@/main/components/shared/asyncModalConfirm/asyncModalConfirm";
import { isNullUndefined } from "@/main/services/reducerUtils";

interface IReasonInputProps {
	fieldPrefix: string;
	hasReadOnly?: boolean;
	isShowModalReasonAll?: boolean;
	allSelected?: boolean;
	setIsShowModalReasonAll?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ColumnReason({
	fieldPrefix,
	hasReadOnly,
	isShowModalReasonAll,
	allSelected,
	setIsShowModalReasonAll,
}: IReasonInputProps) {
	const { control, setValue, getValues } = useFormContext<ICreateAnswerForm>();
	const [getConfirmattion, ModalConfirmation] = useAsyncModalConfirm();

	const watcherNotQuote = useWatch({
		control,
		name: `${fieldPrefix}.notQuote` as any,
		defaultValue: false,
	});
	const watcherReason = useWatch({
		control,
		name: `${fieldPrefix}.reason` as any,
		defaultValue: false,
	});
	const watcherObservation = useWatch({
		control,
		name: `${fieldPrefix}.observation` as any,
		defaultValue: false,
	});

	const { reason: reasonReducer } = useReasonReducer();

	const isDisabledObservation = () => convertStringForBoolean(watcherReason?.default);

	if (!watcherNotQuote) return <></>;

	function getNotQuoteAndReasonRows() {
		const items = getValues("pendingItems");

		return items;
	}

	async function handleModalReasonAll() {
		if (!watcherReason || !allSelected) {
			setIsShowModalReasonAll?.(true);
			return;
		}

		if (!isShowModalReasonAll) return;

		if (!isNullUndefined(setIsShowModalReasonAll)) {
			setIsShowModalReasonAll(false);
		}

		const isConfirmModal = await getConfirmattion(getTranslateByKey("information.applyReasonQuotedPart"));

		if (!isConfirmModal) return;

		const itemsToUpdate = getNotQuoteAndReasonRows();

		itemsToUpdate.forEach((_, index) => {
			setValue(`pendingItems.${index}.notQuote` as any, true);
			setValue(`pendingItems.${index}.reason` as any, watcherReason);
			if (isDisabledObservation()) {
				setValue(`pendingItems.${index}.observation` as any, watcherObservation);
			}
		});
	}

	return (
		<>
			<KogAutoCompleteOutlinedControlled
				className="ignore-click"
				id="id-createAnswer-text-reason"
				required
				label={getTranslateByKey("information.reason")}
				placeholder={getTranslateByKey("information.reason")}
				nameCustom={`${fieldPrefix}.reason`}
				disabledMessage
				control={control}
				setValueCustom={setValue}
				disabled={hasReadOnly}
				options={reasonReducer.data}
				isLoading={reasonReducer.isLoading}
				rulesCustom={{ required: true }}
				onChangeCustom={() => {}}
				onBlur={handleModalReasonAll}
				style={{ marginTop: 10, marginBottom: 10 }}
			/>

			<ModalConfirmation />
			{isDisabledObservation() && (
				<KogTextAreaControlledNew
					id="id-createAnswer-text-observation"
					name={`${fieldPrefix}.observation`}
					required
					disabled={hasReadOnly}
					control={control}
					disabledMessage
					autoFocus
					rulesCustom={{
						required: isDisabledObservation(),
					}}
					label={getTranslateByKey("information.observation")}
				/>
			)}
		</>
	);
}
